import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/ScrollBlur.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/BrandStrip.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/channels/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/ContactCTA.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/Manifesto.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/measurement/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/Problem.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/services/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/SocialProof.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/VODShowsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/LangToggle.tsx");
